window.addEventListener("DOMContentLoaded", function () {
  theme.jQuery(function ($) {
    var css = '';

    $('.option--color ul.clickyboxes').each(function (i, ul) {
      var $select = $(ul).siblings('select');

      $(ul).find('li').each(function (j, li) {
        var $option = $select.find('option').eq(j);
        var $a = $(li).find('a');
        var opt = Array.from($a[0].classList).filter(function (el) { return /^opt--/.test(el); })[0];

        $a.attr('href', $option.attr('data-product-url'));

        console.log({ ul, li, $select, $option, $a, opt });

        css += '.option--color select[data-colour-swatch="true"] + .clickyboxes .' + opt + '::before { background-image: url(' + $option.attr('data-swatch-url') + '); }' + "\n";
      });
    });

    $('body').append($('<style/>').attr('id', 'swatch-images').text(css));

    $('.option--color select.clickybox-replaced').on(
      "change.clickyboxes keyup.clickyboxes",
      function (e) {
        var $option = $(this).find('option:selected');
        console.log("click.clickyboxes", e, this, $option);

        window.location.href = $option.attr('data-product-url');
      }
    );

    $('.shopify-section.section-newsletter').before(
      $('<div class="back-to-top" />')
        .html(
          // '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" /></svg>' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clip-rule="evenodd" /></svg>' +
          '<span>Back to top</span>'
        )
        .on('click', function (e) {
          $(window).scrollTop(0);
        })
    );
  });
});
